import React from 'react';
import PropTypes from 'prop-types';
import {
  LazyLoadComponent as ReactLazyLoadComponent, trackWindowScroll
} from 'react-lazy-load-image-component';

const DEFAULT_HEIGHT = "300px";
const DEFAULT_WIDTH = "100%";

const LazyLoadComponent = (props) => (
  <ReactLazyLoadComponent
    height={DEFAULT_HEIGHT}
    width={DEFAULT_WIDTH}
    {...props}
  />
);

export { LazyLoadComponent, trackWindowScroll };
